// import logo from './logo.svg';
import "./App.css";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import WithHeaderFooter from "./component/WithHeaderFooter";
import WithHeaderFooterAndMenu from "./component/WithHeaderFooterAndMenu";
import CouponMaster from "./pages/CouponMaster";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import VendorLogin from "./pages/VendorLogin";
import Member from "./pages/Register/Member";
import MemberDetails from "./pages/Member/MemberDetails";
import Vendor from "./pages/Register/Vendor";
import VendorDetails from "./pages/Vendor/VendorDetails";
import VendorDetailsNew from "./pages/Vendor/VendorDetailsNew";

import { APIProvider } from "@vis.gl/react-google-maps";
import CategoryTable from "./pages/CategoryTable";
import MemberTable from "./pages/MemberTable";
import VendorTable from "./pages/VendorTable";

import Verify from "./pages/Register/Verify";
import { GlobalProvider } from "./component/GlobalContext";
import VendorGalleryAdd from './pages/Vendor/VendorGalleryAdd';
import AdminGalleryAdd from './pages/AdminGalleryAdd';
import AdminGalleryEdit from './pages/AdminGalleryEdit';

import EventAdd from './pages/EventAdd';
import EventDetails from "./pages/EventDetails";
import EventCalender from "./pages/EventCalender";
import Explore from './pages/Explore/Explore';
import MemberShip from "./pages/Member/MemberShip";
import Modal from 'react-modal';
import VendorSubscription from "./pages/Vendor/VendorSubscription";
import PaymentSuccess from "./pages/Payment/PaymentSuccess";
import PaymentCancel from "./pages/Payment/PaymentCancel";
import PageNotFound from "./pages/Payment/PageNotFound";
import MemberEdit from "./pages/MemberEdit";
import EventEdit from "./pages/EventEdit";
import VendorEdit from "./pages/VendorEdit";
import ContactUs from "./pages/ContactUs";
import RefundPolicy from "./pages/RefundPolicy";
import EventList from "./pages/EventList";
import ImageGallery from "./component/ui/ImageGallery";
import GridImageGallery from "./pages/ImageGallery/GridImageGallery";
import Businesslist from "./pages/BusinessList/Businesslist";
import { MemberShipCardStructure } from "./component/ReusableComponents";
import VendorRegistration from "./pages/VendorRegistration";
import './styling/Responsive.css'
// Set the root element of your app
Modal.setAppElement('#root');


function App() {
  return (
    <Router>
      <GlobalProvider>
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
          <Routes>
            {/* <Route path="/" element={<Home />} /> */}
            <Route
              path="/"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <Home />
                </WithHeaderFooter>
              }
            />
            <Route path="*" element={
              <WithHeaderFooter smallCardAlignment="flex-col">
                {/* <Home /> */}
                <PageNotFound />
              </WithHeaderFooter>
            } />
            <Route
              path="/alter"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <Home />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/forgotpassword"
              element={
                <WithHeaderFooter smallCardAlignment="custom-wrapper-height">
                  <ForgotPassword />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/login"
              element={
                <WithHeaderFooter smallCardAlignment="custom-wrapper-height">
                  <Login />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/vendor/login"
              element={
                <WithHeaderFooter smallCardAlignment="custom-wrapper-height">
                  <VendorLogin />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/vendor/registration"
              element={
                <WithHeaderFooter smallCardAlignment="custom-wrapper-height">
                  <VendorRegistration/>
                </WithHeaderFooter>
              }
            />
            <Route
              path="/verify"
              element={
                <WithHeaderFooter smallCardAlignment="custom-wrapper-height">
                  <Verify />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/member/register"
              element={
                <WithHeaderFooter smallCardAlignment="">
                  <Member />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/vendor/register"
              element={
                <WithHeaderFooter >
                  <Vendor />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/vendor/gallery/create"
              element={
                <WithHeaderFooter>
                  <VendorGalleryAdd />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/accordion-gallery"
              element={<WithHeaderFooter>
                <ImageGallery />
              </WithHeaderFooter>}
            />


            <Route
              path="/gallery"
              element={<WithHeaderFooter>
                <GridImageGallery />
              </WithHeaderFooter>}
            />


            <Route

              path="/vendor/details/new/:id"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <VendorDetails />
                </WithHeaderFooter>
              }
            />

            <Route
              path="/vendor/details/:id"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <VendorDetailsNew />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/dashboard"
              element={
                <WithHeaderFooterAndMenu>
                  <Dashboard />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/account-details"
              element={
                <WithHeaderFooterAndMenu>
                  <Account />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/coupons"
              element={
                <WithHeaderFooterAndMenu>
                  <CouponMaster />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/tesitng"
              element={
                <WithHeaderFooterAndMenu>
                  <MemberShipCardStructure/>
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/business-list-directory"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <Businesslist />
                </WithHeaderFooter>
                
              }
            />
            <Route
              path="/media-gallery"
              element={
                <WithHeaderFooterAndMenu>
                  <AdminGalleryAdd />
                </WithHeaderFooterAndMenu>
              }
            />
            
            <Route
              path="/media-gallery/:id"
              element={
                <WithHeaderFooterAndMenu>
                  <AdminGalleryEdit />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/events"
              element={
                <WithHeaderFooterAndMenu>
                  <EventList />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/events/create"
              element={
                <WithHeaderFooterAndMenu>
                  <EventAdd />
                </WithHeaderFooterAndMenu>
              }
            />
            {/* <Route
              path="/events"
              element={
                <WithHeaderFooterAndMenu>
                  <EventList />
                </WithHeaderFooterAndMenu>
              }
            /> */}
            <Route
              path="/categories"
              element={
                <WithHeaderFooterAndMenu>
                  <CategoryTable />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/members"
              element={
                <WithHeaderFooterAndMenu>
                  <MemberTable />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/members/:id"
              element={
                <WithHeaderFooterAndMenu>
                  <MemberEdit />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/events/edit/:id"
              element={
                <WithHeaderFooterAndMenu>
                  <EventEdit />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/vendors"
              element={
                <WithHeaderFooterAndMenu>
                  <VendorTable />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/vendors/:id"
              element={
                <WithHeaderFooterAndMenu>
                  <VendorEdit />
                </WithHeaderFooterAndMenu>
              }
            />
            <Route
              path="/explore"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <Explore />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/contact-us"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <ContactUs />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/refund-policy"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <RefundPolicy />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/subscription/member"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <MemberShip />
                </WithHeaderFooter>
              }
            />

            <Route
              path="/subscription/member"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <MemberShip />
                </WithHeaderFooter>
              }
            />

            <Route
              path="/subscription/vendor"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  {/* <MemberShip /> */}
                  <VendorSubscription />
                </WithHeaderFooter>
              }
            />

            <Route
              path="/payment/success"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <PaymentSuccess />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/payment/cancel"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <PaymentCancel />
                </WithHeaderFooter>
              }
            />

            <Route
              path="/event-calender"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <EventCalender />
                </WithHeaderFooter>
              }
            />
            <Route
              path="/events/:id"
              element={
                <WithHeaderFooter smallCardAlignment="flex-col">
                  <EventDetails />
                </WithHeaderFooter>
              }
            />
          </Routes>
        </APIProvider>
      </GlobalProvider>
    </Router>
  );
}

export default App;
